import { VFC, useMemo } from "react";
import { BooleanDataField } from "src/types/data-field.types";
import { NodeData } from "src/types/node.types";
import { nanoid } from "nanoid";
import { css } from "src/styles/theme";
import { CheckIcon } from "@radix-ui/react-icons";
import * as Checkbox from "@radix-ui/react-checkbox";

export interface CheckboxFieldProps {
  field: BooleanDataField;
  data: NodeData;
  onChange: (data: NodeData) => void;
}

export const CheckboxField: VFC<CheckboxFieldProps> = (props) => {
  const id = useMemo(() => `id-${nanoid()}`, []);
  const key = props.field.key;
  const onCheckedChangeHandler = (checked: boolean) => {
    props.onChange({ ...props.data, [key]: checked });
  };

  const value = props.data[key] as boolean;

  return (
    <div className={$wrapper()}>
      <Checkbox.Root
        id={id}
        checked={value}
        onCheckedChange={onCheckedChangeHandler}
        className={$checkbox()}
      >
        <Checkbox.Indicator className={$indicator()}>
          <CheckIcon />
        </Checkbox.Indicator>
      </Checkbox.Root>
      <label htmlFor={id} className={$label()}>
        {props.field.label}
      </label>
    </div>
  );
};

const $wrapper = css({
  display: "flex",
  alignItems: "center",
});

const $checkbox = css({
  applyReset: "btn",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  borderRadius: "$1",
  backgroundColor: "$primaryBg",

  "&:hover, &:focus": {
    outline: 0,
    backgroundColor: "$primaryBgHover",
  },
});

const $indicator = css({
  display: "flex",
  color: "$primaryText",
});

const $label = css({
  margin: 0,
  paddingLeft: "$2",
  color: "$primaryText",
  fontSize: "$sm",
  cursor: "pointer",
  userSelect: "none",
});
